import request from './request'

export function listAnomalyReason(data) {
  return request.post('/mes/anomaly-reasons/list', data)
}
export function selectAnomalyReason() {
  return request.get('/mes/anomaly-reasons/select')
}
export function getAnomalyReason(id) {
  return request.get('/mes/anomaly-reasons/' + id)
}
export function saveAnomalyReason(data) {
  return request.post('/mes/anomaly-reasons', data)
}
export function updateAnomalyReason(data) {
  return request.post('/mes/anomaly-reasons/update', data)
}
export function deleteAnomalyReason(ids) {
  return request.post('/mes/anomaly-reasons/delete', ids)
}
